import { Activity } from "lucide-react";

export default function ActivityView({ logs }) {
  return (
    <div className="space-y-6">
      <div>
        <span className="overline text-gold">Registro en tiempo real</span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold">Actividad</h2>
      </div>
      <div className="card-surface overflow-hidden" data-testid="activity-list">
        <div className="px-5 py-3 border-b border-white/10">
          <span className="overline">Últimos comandos ejecutados</span>
        </div>
        {(!logs || logs.length === 0) ? (
          <div className="p-10 text-center text-muted-foreground text-sm">
            <Activity className="mx-auto mb-3 opacity-40" size={36} />
            Sin actividad todavía.
          </div>
        ) : (
          <div className="divide-y divide-white/5 max-h-[65vh] overflow-y-auto scrollbar-thin">
            {logs.map((l, i) => (
              <div key={i} className="flex items-center justify-between gap-3 px-5 py-3" data-testid="activity-row">
                <div className="flex items-center gap-3 min-w-0">
                  <span className="font-mono text-gold text-sm shrink-0">!{l.command}</span>
                  <span className="text-xs text-muted-foreground truncate">{l.groupName || l.chatId}</span>
                </div>
                <div className="text-xs text-muted-foreground shrink-0 font-mono">
                  {l.sender} · {new Date(l.timestamp).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
